import { cn } from '@/utils/cn';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Loader({ size = 'md', className }: LoaderProps) {
  const sizeValues = {
    sm: { container: 50, dot: 20 },
    md: { container: 75, dot: 30 },
    lg: { container: 100, dot: 40 },
  };

  const { container, dot } = sizeValues[size];

  return (
    <div className={cn('relative', className)} style={{ width: container, height: container }}>
      <div className="loader-inner" style={{ width: container, height: container }}>
        <div className="dot white" style={{ width: dot, height: dot }}></div>
        <div className="dot" style={{ width: dot, height: dot, background: '#FF4444' }}></div>
        <div className="dot" style={{ width: dot, height: dot, background: '#FFBB33' }}></div>
        <div className="dot" style={{ width: dot, height: dot, background: '#99CC00' }}></div>
        <div className="dot" style={{ width: dot, height: dot, background: '#33B5E5' }}></div>
      </div>
      <style>{`
        .loader-inner {
          position: relative;
          animation: rotate5123 2.4s linear infinite;
        }

        .white {
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          background: white;
          animation: flash 2.4s linear infinite;
          opacity: 0;
        }

        .dot {
          position: absolute;
          margin: auto;
          border-radius: 100%;
          transition: all 1s ease;
        }

        .dot:nth-child(2) {
          top: 0;
          bottom: 0;
          left: 0;
          animation: dotsY 2.4s linear infinite;
        }

        .dot:nth-child(3) {
          left: 0;
          right: 0;
          top: 0;
          animation: dotsX 2.4s linear infinite;
        }

        .dot:nth-child(4) {
          top: 0;
          bottom: 0;
          right: 0;
          animation: dotsY 2.4s linear infinite;
        }

        .dot:nth-child(5) {
          left: 0;
          right: 0;
          bottom: 0;
          animation: dotsX 2.4s linear infinite;
        }

        @keyframes rotate5123 {
          0% {
            transform: rotate( 0 );
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes dotsY {
          0%, 100% {
            opacity: 1;
            transform: scaleX(1);
          }
          50% {
            opacity: 0.3;
            transform: scaleX(0.5);
          }
        }

        @keyframes dotsX {
          0%, 100% {
            opacity: 1;
            transform: scaleY(1);
          }
          50% {
            opacity: 0.3;
            transform: scaleY(0.5);
          }
        }

        @keyframes flash {
          33% {
            opacity: 0;
            border-radius: 0%;
          }

          55% {
            opacity: .6;
            border-radius: 100%;
          }

          66% {
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}
